//
// AbstractConstraintType.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../BIRDModel";
import "@sas-dvr/ltjs-commons/models/data/dataset/DataUsage";

var AbstractConstraintType = createModule("BIRD::AbstractConstraintType", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        maxInclusive: 2,
        min: 7,
        max: 7,
        minInclusive: 2,
        required: 2,
    },
    ,
    ,
    {
        getDataUsage: [4],
    },
    ,
    ,
]);
export default AbstractConstraintType;
